import { useEffect } from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/contact";

export const FloatingWhatsApp = () => {
  useEffect(() => {
    // smooth-reveal entrance
  }, []);
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label="WhatsApp'tan yaz"
      className="fixed bottom-24 right-4 md:bottom-6 md:right-6 z-40 inline-flex items-center gap-3 bg-gradient-to-r from-[#25D366] to-[#1ebd5b] text-white px-4 py-3 md:px-5 md:py-4 font-extrabold text-xs md:text-sm uppercase tracking-[0.18em] rounded-full shadow-[0_18px_40px_-12px_rgba(37,211,102,0.55)] hover:-translate-y-0.5 transition-all duration-300"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline">WhatsApp</span>
    </a>
  );
};

export default FloatingWhatsApp;
